import { Component, OnInit, Directive } from "@angular/core";
import { ModalController, NavParams } from "@ionic/angular";
import { AppService } from "src/app/app.service";
import { Subject } from "rxjs";
import { Global } from "src/global";
import { Router, ActivatedRoute } from "@angular/router";
import { DomSanitizer } from "@angular/platform-browser";
import { ElementRef, ViewChild } from "@angular/core";
import { ModalPage } from "src/app/modals/modal/modal.page";

@Component({
  selector: "app-media",
  templateUrl: "./media.page.html",
  styleUrls: ["./media.page.scss"],
})
export class MediaPage implements OnInit {
  callingFilter: string;
  User_GUID: string;
  Vendor_GUID: string;
  mediaSelectionList: any = [];
  mediaSelectionList_Master: any = [];
  //mediaSelectionSelectedList: any;
  loadingDone: boolean = false;
  searchText: string = "";
  mediaTypeSelected: string = "Videos";
  skip: any = 0;
  take: any = 30;
  heading: string;
  additionalText: string;
  selectedList: any = [];
  sceneMediaSelectionList_Master: any = [];
  sceneMediaSelectionList: any = [];
  isDragging: boolean = false;
  contentUploaded: any;
  totalFilesUploaded: number = 0;
  totalFilesProcessed: number = 0;
  @ViewChild("fileInput") fileInput: ElementRef;

  constructor(
    private modalController: ModalController,
    private navParams: NavParams,
    private appservice: AppService,
    public globals: Global,
    private router: Router,
    public sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.heading = this.navParams.data.paramObject.heading;
    this.additionalText = this.navParams.data.paramObject.additionalText;

    this.GetContentList();
    this.GetMediaSelectionList();
  }

  async showContent(name: string, Content_GUID: string) {
    var paramObject = {
      modalType: "contentViewer",
      modalBodyText: "",
      modalHeaderText: name,
      Content_GUID: Content_GUID,
    };

    const modal = await this.modalController.create({
      component: ModalPage,
      componentProps: {
        paramObject: paramObject,
      },
      cssClass: "modal-fullscreen",
    });

    modal.onDidDismiss().then((dataReturned) => {
      if (dataReturned !== null) {
      }
    });
    return await modal.present();
  }

  search() {
    // if (this.searchText != "") {
    //   //this.sceneMediaSelectionList = this.sceneMediaSelectionList_Master.filter(x => x.SceneName.toLowerCase() == this.searchText.toLowerCase());
    //   this.sceneMediaSelectionList = this.sceneMediaSelectionList_Master.filter(c => c.SceneName.includes(this.searchText))
    // }
    // else
    //   this.sceneMediaSelectionList = this.sceneMediaSelectionList_Master;

    // this.GetContentList();
    // this.GetMediaSelectionList();

    if (this.searchText != "") {
      this.sceneMediaSelectionList = this.sceneMediaSelectionList_Master.filter(
        (c) =>
          c.SceneName?.toLowerCase().includes(this.searchText.toLowerCase())
      );
      //this.mediaSelectionList = this.mediaSelectionList_Master.filter((item) =>
      //item.description?.toLowerCase().includes(this.searchText.toLowerCase())

      this.mediaSelectionList = this.mediaSelectionList_Master.filter(
        (item) =>
          (item.description
            ?.toLowerCase()
            .includes(this.searchText.toLowerCase()) ??
            false) ||
          (item.tags?.toLowerCase().includes(this.searchText.toLowerCase()) ??
            false)
      );
    } else {
      this.mediaSelectionList = this.mediaSelectionList_Master;
      this.sceneMediaSelectionList = this.sceneMediaSelectionList_Master;
    }
  }

  async onMediaSelectionSelect(event: any, mediaSelection: any) {
    mediaSelection.isChecked = !mediaSelection.isChecked;
  }

  GetContentList() {
    this.loadingDone = false;
    var subject = new Subject<any>();

    const formData: FormData = new FormData();

    formData.append("GUID", this.globals.XRSUser.GUID);
    formData.append("search", this.searchText);
    formData.append("type", this.mediaTypeSelected);
    formData.append("filter", "AllMedia");
    formData.append("sort", "Created");
    formData.append("skip", "" + this.skip);
    formData.append("take", "" + this.take);

    this.appservice.GetContentList(formData).subscribe((res) => {
      try {
        this.loadingDone = true;
        var returnedItems = JSON.parse(res.toString());
        this.sceneMediaSelectionList = returnedItems;
        this.sceneMediaSelectionList_Master = returnedItems;
      } catch (e) { }
    });

    return subject.asObservable();
  }

  GetMediaSelectionList() {
    this.loadingDone = false;

    var subject = new Subject<any>();

    const formData: FormData = new FormData();

    formData.append("GUID", this.globals.XRSUser.GUID);
    formData.append("search", this.searchText);
    formData.append("type", this.mediaTypeSelected);
    formData.append("filter", "AllMedia");
    formData.append("sort", "Created");
    formData.append("skip", "" + this.skip);
    formData.append("take", "" + this.take);

    this.appservice.GetMediaList(formData).subscribe((res) => {
      try {
        this.loadingDone = true;
        var returnedItems = JSON.parse(res.toString());

        // if (this.mediaSelectionList.length == 0) {
        //   this.mediaSelectionList = returnedItems;

        // } else {
        //   this.mediaSelectionList =
        //     this.mediaSelectionList.concat(returnedItems);

        // }

        // this.mediaSelectionList.forEach(element => {
        //   element.isSelected = false;
        // });

        this.mediaSelectionList = returnedItems;
        this.mediaSelectionList_Master = returnedItems;
      } catch (e) { }
    });

    return subject.asObservable();
  }

  transformNestedJsonArray(nestedArray: any[]): any[] {
    var result: any[] = [];
    nestedArray.forEach((item) => {
      item.media.forEach((element) => {
        result.push(element);
      });
      item.question.forEach((element) => {
        result.push(element);
      });
    });
    return result;
  }

  setMediaTypeSelected(mediaTypeSelected: any) {
    //if tab changed
    // if (this.mediaTypeSelected != mediaTypeSelected) {

    //   this.mediaTypeSelected = mediaTypeSelected;

    //   this.GetMediaSelectionList();

    //   if (mediaTypeSelected == 'Scenes') {

    //   }
    //   if (mediaTypeSelected == 'Videos') {
    //     //this.mediaSelectionList = this.transformNestedJsonArray(this.sceneMediaSelectionList).filter(x => x.SceneSequenceType_GUID == '3114BE04-0D71-48D7-AEE0-D2402F499051');
    //   }
    //   if (mediaTypeSelected == 'Pictures') {
    //     //this.mediaSelectionList = this.transformNestedJsonArray(this.sceneMediaSelectionList).filter(x => x.SceneSequenceType_GUID == '1E9A312A-A1C7-4FC1-B911-DFAFBDD3023A');
    //   }
    //   if (mediaTypeSelected == 'Documents') {
    //     //this.mediaSelectionList = this.transformNestedJsonArray(this.sceneMediaSelectionList).filter(x => x.SceneSequenceType_GUID == '2F86C1C8-7126-4A3B-9895-96B04F79374E');
    //   }
    // }
    if (this.mediaTypeSelected !== mediaTypeSelected) {
      this.mediaTypeSelected = mediaTypeSelected;
      this.GetMediaSelectionList();
    }
  }

  handleDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = true;
  }

  handleDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false;

    const files = event.dataTransfer?.files;
    if (files.length > 0) {
      this.handleDroppedFiles(files);
    }
  }

  handleDroppedFiles(files: FileList): void {
    //this.uploadDone = false;
    this.totalFilesUploaded = this.totalFilesUploaded = files.length;
    this.totalFilesProcessed = this.totalFilesUploaded;
    for (let i = 0; i < files.length; i++) {
      const file: File = files.item(i);

      const formData = new FormData();
      formData.append("UploadedFile", file, file.name);
      formData.append("Description", file.name);
      formData.append("User_GUID", this.globals.XRSUser.GUID);
      formData.append("Site_GUID", this.globals.XRSUser.Site_GUID);
      formData.append("Site_ID", this.globals.XRSUser.Site_ID);
      formData.append("isSTSContent", "true");

      this.appservice.UploadPost(formData).subscribe((res) => {
        try {
          this.totalFilesProcessed--;
          let selectedFiles: any[] = [];

          this.contentUploaded = JSON.parse(res.toString());
          this.contentUploaded.url =
            this.globals.GetXRSCustomContentURL() + this.contentUploaded.GUID;
          this.contentUploaded.contentType = this.contentUploaded.GUID;
          selectedFiles.push(this.contentUploaded);

          for (const file of selectedFiles) {
            selectedFiles = [];
            formData.append("Content_GUID", file.GUID);

            this.appservice
              .GetContentByGUID(formData)
              .subscribe(async (res) => {
                //this.uploadDone = true;

                try {
                  let contentObject = JSON.parse(res.toString());

                  this.showContent(contentObject.text, contentObject.GUID);

                  // if (contentObject) {
                  //   this.sanitizedURL =
                  //     this.sanitizer.bypassSecurityTrustResourceUrl(
                  //       this.globals.XRSBaseURLWebLMS + contentObject.Location
                  //     );
                  //   this.Lesson.children
                  //     .find((x) => x.GUID == this.menuOptionTreeModule.GUID)
                  //     .children.find(
                  //       (y) => y.GUID == this.menuOptionTreeScene.GUID
                  //     )
                  //     .children.push(contentObject);
                  // }
                } catch (e) { }
              });
          }
        } catch (e) {
          console.error("Error parsing response", e);
        }
      });
    }
  }

  async GetQuestionDetails(questionList) {
    var questionItemList = [];
    questionList.forEach((element) => {
      const formData: FormData = new FormData();
      formData.append("Question_GUID", element.Question_GUID);
      this.appservice.GetQuestionByGUIDCB(formData).subscribe(async (res) => {
        try {
          questionItemList.push(JSON.parse(res.toString()));
        } catch (e) { }
      });
      return questionItemList;
    });
  }

  async closeModal() {
    await this.modalController.dismiss(null);

    this.router.navigate(["/manage-content"]);
  }

  async onCloseUpload() {
    
    var mediaList: any = [];
    var questionList: any = [];
    var tempsceneMediaSelectionList = this.transformNestedJsonArray(
      this.sceneMediaSelectionList
    );

    //loop through content selected in the section tab
    tempsceneMediaSelectionList.forEach((elem) => {
      if (elem.isChecked && elem.type == "media") {
        mediaList.push(elem);
      }
      if (elem.isChecked && elem.type == "question") {
        questionList.push(elem);
      }
    });

    this.mediaSelectionList.forEach((elem) => {
      if (elem.isChecked) {
        mediaList.push(elem);
      }
    });

    const formData: FormData = new FormData();

    formData.append("mediaList", JSON.stringify(mediaList));

    this.appservice.GetContentListDetails(formData).subscribe(async (res) => {
      try {
        var returnedItems = JSON.parse(res.toString());

        const formData: FormData = new FormData();

        formData.append("questionList", JSON.stringify(questionList));

        this.appservice
          .GetQuestionListDetails(formData)
          .subscribe(async (res) => {
            try {
              var returnedItemsQA = JSON.parse(res.toString());

              var returnData = {
                MediaData: returnedItems,
                QAData: returnedItemsQA,
              };

              await this.modalController.dismiss(returnData);
            } catch (e) { }
          });
      } catch (e) { }
    });
  }

  clearList() {
    this.mediaSelectionList = [];
    this.skip = 0;
    this.take = 30;
  }

  loadMoreData(event: any) {
    this.skip += this.take;
    //this.GetMediaSelectionList();
    event.target.complete();
  }

  onTabClick(mediaType: string) {
    this.setMediaTypeSelected(mediaType);
    this.router.navigate([`/media/${mediaType.toLowerCase()}`]);
  }
}
